module.exports = __webpack_public_path__ + "img/background-4.2bbc31b5.jpg";